import { render } from "./students_barcodes.vue?vue&type=template&id=b5fb9072"
import script from "./students_barcodes.vue?vue&type=script&lang=js"
export * from "./students_barcodes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__